import VScrollLock from 'v-scroll-lock';
import InstantSearch from 'vue-instantsearch/vue3/es';
import { ComponentLibrary } from '@ankorstore/design-system';
import PortalVue from 'portal-vue';
import { createPrismic } from '@prismicio/vue';
import VueTelInput from '@ankorstore/vue-tel-input';
import '@ankorstore/vue-tel-input/vue-tel-input.css';
import config from './prismic.config.json';
import popperjs from 'popper.js';
import { breakpointsPlugin } from '@monolith/legacy/modules/design-system-candidates/breakpoints/breakpoints-plugin';
import { SearchAiPlugin } from '@ankorstore/search-ai'
import { getLang } from '@core/utilities/lang';


export default {
  install(app) {
    window.Popper = popperjs;

    app.use(VScrollLock);
    app.use(
      createPrismic({
        endpoint: config.prismicApiEndpoint,
      })
    );
    app.use(InstantSearch);
    app.use(ComponentLibrary);
    app.use(VueTelInput);
    app.use(SearchAiPlugin, {locale: getLang()})

    app.use(PortalVue, {
      portalName: false,
      portalTargetName: false,
    });
    app.use(breakpointsPlugin);
  },
};
